export default __webpack_public_path__ + "static/media/available_default_cached.a28f3c9b.svg";